export const headerNav = [
  { id: 'updates', label: '最新快讯' },
  { id: 'index', label: '专题合集' },
  { id: 'carousel', label: '焦点专题' },
  { id: 'faq', label: '吃瓜问答' },
  { id: 'about', label: '关于本站' },
];

export const heroData = {
  tag: '🔥 今日热搜',
  h1: '52吃瓜网 — 娱乐圈第一手爆料平台',
  slogan: '每天3分钟，吃遍全网最新鲜的瓜',
  intro: '52吃瓜网是专注于娱乐圈实时八卦与热点爆料的资讯聚合平台，每日追踪明星动态、综艺内幕、影视花絮与社交平台热搜事件。我们汇聚全网最热门的52吃瓜爆料，以最快的速度为你呈现今日娱乐圈最新消息。无论是明星恋情曝光、剧组路透花絮，还是综艺录制幕后故事，52吃瓜网都在第一时间为你揭秘。',
  stats: [
    { value: '实时更新', label: '7×24小时追踪' },
    { value: '全平台覆盖', label: '微博·抖音·小红书' },
    { value: '每日50+', label: '新鲜爆料推送' },
  ],
  primaryCta: { label: '立即吃瓜', href: '#updates' },
  secondaryCta: { label: '了解我们', href: '#about' },
  heroImage: 'https://readdy.ai/api/search-image?query=Vibrant%20abstract%20illustration%20of%20entertainment%20gossip%20and%20social%20media%20trending%20topics%2C%20stylized%20magazine%20collage%20with%20warm%20coral%20and%20gold%20tones%2C%20dynamic%20composition%20with%20floating%20speech%20bubbles%20and%20news%20elements%2C%20modern%20editorial%20design%20with%20soft%20gradients%2C%20clean%20artistic%20style%20on%20warm%20cream%20background&width=1200&height=900&seq=hero-main-2026&orientation=portrait',
};

export const indexItems = [
  { title: '明星恋情追踪', icon: 'ri-heart-line', count: '126篇', desc: '最新明星恋情曝光与甜蜜互动合集', color: 'primary' },
  { title: '综艺录制路透', icon: 'ri-camera-line', count: '89篇', desc: '热门综艺现场路透与幕后花絮', color: 'accent' },
  { title: '影视剧集爆料', icon: 'ri-film-line', count: '203篇', desc: '新剧开拍、演员阵容、剧情前瞻', color: 'primary' },
  { title: '社交平台热搜', icon: 'ri-fire-line', count: '341篇', desc: '微博抖音小红书热门话题汇总', color: 'accent' },
  { title: '明星翻车现场', icon: 'ri-emotion-line', count: '67篇', desc: '明星翻车名场面与争议事件', color: 'primary' },
  { title: '时尚穿搭点评', icon: 'ri-t-shirt-line', count: '154篇', desc: '明星红毯与日常穿搭专业点评', color: 'accent' },
  { title: '音乐圈动态', icon: 'ri-music-line', count: '112篇', desc: '新歌发布、演唱会、音乐节信息', color: 'primary' },
  { title: '网红圈八卦', icon: 'ri-live-line', count: '278篇', desc: '头部网红动态与直播圈热议话题', color: 'accent' },
  { title: '港台娱乐圈', icon: 'ri-global-line', count: '95篇', desc: '港台明星最新动态与经典回顾', color: 'primary' },
];

export const carouselItems = [
  {
    title: '《星光之夜》录制现场独家路透',
    category: '综艺路透',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20TV%20show%20recording%20studio%20with%20warm%20stage%20lighting%2C%20artistic%20rendering%20with%20soft%20coral%20and%20gold%20tones%2C%20modern%20editorial%20style%20on%20cream%20background%2C%20clean%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    excerpt: '多位一线明星齐聚录制现场，节目组保密工作严密但仍有路透流出...',
    tag: 'HOT',
  },
  {
    title: '某顶流疑似恋情曝光？工作室回应引热议',
    category: '明星恋情',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20romantic%20celebrity%20gossip%20theme%2C%20soft%20artistic%20rendering%20with%20warm%20rose%20and%20cream%20tones%2C%20magazine%20editorial%20style%20with%20delicate%20composition%2C%20modern%20minimalist%20design&width=800&height=500&seq=carousel-02&orientation=landscape',
    excerpt: '网友偶遇某当红艺人深夜与神秘人同行，照片引发全网猜测...',
    tag: 'NEW',
  },
  {
    title: '暑期档电影票房大战：谁能笑到最后',
    category: '影视资讯',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20cinema%20and%20box%20office%20theme%2C%20stylized%20movie%20elements%20with%20warm%20amber%20and%20gold%20tones%2C%20modern%20editorial%20design%20with%20dynamic%20composition%2C%20clean%20artistic%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    excerpt: '多部重磅大片同期上映，票房数据每日刷新，谁将成为暑期档冠军...',
    tag: 'TRENDING',
  },
  {
    title: '某选秀节目选手私下关系大揭秘',
    category: '内幕爆料',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20talent%20show%20and%20competition%20theme%2C%20stylized%20stage%20elements%20with%20warm%20coral%20tones%2C%20modern%20editorial%20composition%20on%20cream%20background%2C%20clean%20design&width=800&height=500&seq=carousel-04&orientation=landscape',
    excerpt: '知情人透露节目中选手之间的真实关系与幕后故事...',
    tag: 'EXCLUSIVE',
  },
  {
    title: '品牌代言风向标：谁是最抢手的带货王',
    category: '商业动态',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20luxury%20brand%20and%20fashion%20theme%2C%20stylized%20shopping%20elements%20with%20warm%20gold%20and%20cream%20tones%2C%20modern%20editorial%20design%2C%20clean%20artistic%20rendering&width=800&height=500&seq=carousel-05&orientation=landscape',
    excerpt: '上半年品牌代言签约盘点，谁拿下了最多顶级品牌资源...',
    tag: 'HOT',
  },
];

export const aboutData = {
  title: '关于52吃瓜网',
  content: '52吃瓜网成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们秉持"快乐吃瓜、理性围观"的理念，每日为百万用户提供最新鲜、最热门的娱乐圈爆料与实时八卦资讯。平台覆盖微博、抖音、小红书等主流社交平台的热搜内容，通过专业编辑团队筛选整理，让用户在最短时间内掌握全网最热的吃瓜动态。52吃瓜网始终坚守内容质量底线，拒绝造谣传谣，只传播经过多方核实的可靠信息。无论是52吃瓜今日爆料还是深度八卦分析，我们都致力于打造最有温度的吃瓜社区。',
};

export const updatesItems = [
  { time: '10分钟前', title: '某知名导演新片开拍，主演阵容意外曝光', tag: '影视', hot: true },
  { time: '28分钟前', title: '热搜第一：某女星深夜发文疑似回应分手传闻', tag: '热搜', hot: true },
  { time: '1小时前', title: '综艺录制现场突发状况，节目组紧急调整流程', tag: '综艺', hot: false },
  { time: '2小时前', title: '某品牌官宣新代言人，粉丝评论区沸腾了', tag: '代言', hot: true },
  { time: '3小时前', title: '音乐节阵容公布，多组艺人确认参演', tag: '音乐', hot: false },
  { time: '5小时前', title: '某剧集路透照流出，服装造型引发热议', tag: '影视', hot: false },
  { time: '7小时前', title: '网红圈最新动态：头部主播转型引发讨论', tag: '网红', hot: false },
  { time: '9小时前', title: '今日娱乐热榜TOP10汇总：吃瓜群众必看', tag: '汇总', hot: true },
];

export const appData = {
  title: '52吃瓜网移动端',
  subtitle: '随时随地，吃瓜不停',
  description: '52吃瓜网移动端已全面上线，支持iOS与Android双平台。关注我们的社交账号，第一时间获取最新52吃瓜爆料与52吃瓜网最新消息推送。',
  icon: 'ri-smartphone-line',
};

export const cardsItems = [
  {
    title: '明星婚后生活大揭秘：谁过得最幸福',
    category: '明星生活',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20family%20and%20lifestyle%20theme%2C%20soft%20artistic%20rendering%20with%20coral%20and%20cream%20tones%2C%20magazine%20editorial%20style%2C%20clean%20modern%20design&width=600&height=400&seq=card-01&orientation=landscape',
    excerpt: '盘点娱乐圈那些婚后依然甜蜜的明星夫妻，谁的爱情保鲜期最长？',
    reads: '12.6万',
  },
  {
    title: '2024十大热搜女王：谁是话题制造机',
    category: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20ranking%20and%20award%20theme%2C%20stylized%20trophy%20elements%20with%20warm%20gold%20tones%2C%20modern%20editorial%20style%2C%20clean%20composition&width=600&height=400&seq=card-02&orientation=landscape',
    excerpt: '从热搜次数到话题影响力，谁才是2024年真正的流量担当？',
    reads: '28.3万',
  },
  {
    title: '剧组幕后那些事：你不知道的拍摄花絮',
    category: '幕后揭秘',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20film%20production%20behind%20the%20scenes%2C%20stylized%20camera%20and%20set%20elements%2C%20warm%20coral%20and%20cream%20tones%2C%20modern%20design&width=600&height=400&seq=card-03&orientation=landscape',
    excerpt: '从NG次数到剧组伙食，带你了解剧组拍摄的真实日常。',
    reads: '9.8万',
  },
  {
    title: '素人逆袭娱乐圈：那些从草根走来的明星',
    category: '励志故事',
    image: 'https://readdy.ai/api/search-image?query=Inspiring%20abstract%20illustration%20of%20success%20and%20journey%20theme%2C%20stylized%20path%20and%20star%20elements%2C%20warm%20amber%20and%20cream%20tones%2C%20modern%20editorial%20design&width=600&height=400&seq=card-04&orientation=landscape',
    excerpt: '没有背景、没有资源，他们凭借实力一步步走到了聚光灯下。',
    reads: '15.1万',
  },
  {
    title: '综艺节目剧本痕迹大分析：真假难辨',
    category: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20TV%20show%20analysis%20theme%2C%20stylized%20script%20and%20magnifying%20glass%20elements%2C%20warm%20coral%20tones%2C%20modern%20editorial%20style&width=600&height=400&seq=card-05&orientation=landscape',
    excerpt: '那些让你哭让你笑的综艺片段，到底有多少是真实的？',
    reads: '21.7万',
  },
];

export const commentsItems = [
  { name: '吃瓜小能手', avatar: '😎', time: '3分钟前', content: '这个瓜我吃了！52吃瓜网真的是娱乐圈信息最全的地方，每天必刷，今天又有新料了！', likes: 256 },
  { name: '娱乐圈观察员', avatar: '🧐', time: '15分钟前', content: '理性分析一下，这条爆料的来源比较可靠，之前也有人发过类似内容，应该不是空穴来风。', likes: 189 },
  { name: '八卦研究员', avatar: '🤓', time: '42分钟前', content: '作为老用户必须说一句，52吃瓜网的内容质量一直很稳定，不像某些平台全是标题党。', likes: 312 },
  { name: '热心群众', avatar: '🍉', time: '1小时前', content: '刚才看到最新爆料，直接惊呆了！这比电视剧还精彩，坐等更多52吃瓜今日爆料。', likes: 178 },
  { name: '老吃瓜人', avatar: '😏', time: '2小时前', content: '跟了52吃瓜网一年多了，每天午休时打开看看，已经成了习惯，内容更新是真的快。', likes: 445 },
];

export const rankingItems = [
  { rank: 1, title: '某顶流艺人深夜约会神秘对象', heat: '98.6万', trend: 'up', category: '恋情' },
  { rank: 2, title: '年度大剧选角内幕：原来主角本是他', heat: '87.3万', trend: 'up', category: '影视' },
  { rank: 3, title: '综艺节目录制事故全程回顾', heat: '76.2万', trend: 'up', category: '综艺' },
  { rank: 4, title: '当红女星时尚活动造型引发两极评价', heat: '65.8万', trend: 'down', category: '时尚' },
  { rank: 5, title: '某歌手新专辑全球销量破纪录', heat: '54.1万', trend: 'up', category: '音乐' },
];

export const mediaItems = [
  { title: '明星红毯高光合集', duration: '03:25', image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20red%20carpet%20fashion%20theme%2C%20stylized%20elegant%20elements%20with%20warm%20gold%20and%20coral%20tones%2C%20modern%20editorial%20style%2C%20clean%20composition&width=640&height=360&seq=media-01&orientation=landscape', category: '时尚' },
  { title: '幕后花絮：那些NG的欢乐瞬间', duration: '05:18', image: 'https://readdy.ai/api/search-image?query=Fun%20abstract%20illustration%20of%20comedy%20and%20blooper%20theme%2C%20stylized%20laughing%20elements%20with%20warm%20amber%20tones%2C%20modern%20editorial%20design%2C%20clean%20artistic%20style&width=640&height=360&seq=media-02&orientation=landscape', category: '搞笑' },
  { title: '一周娱乐大事件回顾', duration: '08:42', image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20news%20recap%20and%20timeline%20theme%2C%20stylized%20calendar%20elements%20with%20warm%20coral%20tones%2C%20modern%20editorial%20style&width=640&height=360&seq=media-03&orientation=landscape', category: '盘点' },
  { title: '明星私服穿搭每日一评', duration: '02:50', image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20fashion%20and%20style%20theme%2C%20stylized%20clothing%20elements%20with%20warm%20coral%20and%20cream%20tones%2C%20modern%20design&width=640&height=360&seq=media-04&orientation=landscape', category: '穿搭' },
  { title: '娱乐圈未解之谜深度解读', duration: '12:15', image: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20illustration%20of%20mystery%20and%20investigation%20theme%2C%20stylized%20question%20mark%20elements%2C%20warm%20gold%20and%20cream%20tones%2C%20modern%20editorial%20style&width=640&height=360&seq=media-05&orientation=landscape', category: '揭秘' },
];

export const faqItems = [
  { q: '52吃瓜网的内容来源是什么？', a: '52吃瓜网的内容来源于全网社交平台、娱乐媒体、官方渠道等多方信息，由专业编辑团队筛选、整理和核实后发布。我们确保每一条52吃瓜爆料都经过多方交叉验证，杜绝虚假信息传播。' },
  { q: '52吃瓜网更新频率如何？', a: '52吃瓜网保持7×24小时全天候更新，编辑团队实时追踪各大平台热点动态，确保52吃瓜网最新消息在第一时间呈现。平均每日更新超过50条新鲜内容，重大事件发生时会在15分钟内快速响应。' },
  { q: '如何获取52吃瓜今日爆料推送？', a: '你可以通过关注我们的社交媒体账号获取实时推送，也可以通过移动端随时随地浏览最新内容。我们会在微博、微信公众号同步更新52吃瓜今日爆料，不错过任何热点。' },
  { q: '52吃瓜网的内容是否可靠？', a: '52吃瓜网始终坚持真实、客观、负责任的报道原则。所有内容在发布前都会经过至少两轮审核，对于未经证实的信息会明确标注"传闻"或"爆料"标签，让读者自行判断。' },
  { q: '如何向52吃瓜网投稿或提供线索？', a: '欢迎通过页面底部的联系方式向我们提供吃瓜线索或投稿。我们设有专门的读者投稿通道，优秀稿件将获得推荐展示机会，并标注投稿人信息。' },
];

export const featuresItems = [
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '7×24小时全天候追踪娱乐圈动态，52吃瓜爆料第一时间送达，重大事件15分钟内上线。', color: 'primary' },
  { icon: 'ri-shield-check-line', title: '真实可靠', desc: '多方信源交叉验证，拒绝谣言与标题党，每一条52吃瓜网最新消息都经过审核把关。', color: 'accent' },
  { icon: 'ri-stack-line', title: '内容全面', desc: '覆盖明星、影视、综艺、音乐、时尚、网红等全领域，满足各类吃瓜群众的八卦需求。', color: 'primary' },
  { icon: 'ri-user-heart-line', title: '用户至上', desc: '百万吃瓜用户的共同选择，打造最有温度、最有态度的娱乐八卦交流社区。', color: 'accent' },
];

export const contactData = {
  title: '联系我们',
  subtitle: '有料就爆，一起吃瓜',
  description: '如果你有娱乐圈最新爆料、明星独家消息或热点事件线索，欢迎通过以下方式联系我们。52吃瓜网始终欢迎读者投稿与线索提供，共同打造最全面的吃瓜资讯平台。',
  email: 'tips@52chigua.com',
  weibo: '@52吃瓜网',
  wechat: '52chiguawang',
};

export const topicsItems = [
  { name: '#顶流恋情曝光', heat: '1028万' },
  { name: '#综艺录制路透', heat: '896万' },
  { name: '#新剧开拍官宣', heat: '765万' },
  { name: '#红毯造型翻车', heat: '723万' },
  { name: '#音乐节全阵容', heat: '689万' },
  { name: '#明星离婚风波', heat: '654万' },
  { name: '#代言人换新', heat: '598万' },
  { name: '#演技名场面', heat: '542万' },
  { name: '#网红转型明星', heat: '487万' },
  { name: '#吃瓜年度盘点', heat: '456万' },
];

export const footerData = {
  description: '52吃瓜网 — 国内领先的娱乐八卦资讯聚合平台。每日更新52吃瓜爆料与52吃瓜网最新消息，追踪52吃瓜今日爆料、实时八卦、吃瓜最新娱乐、娱乐八卦与热搜热点，为百万吃瓜群众提供最新鲜的八卦内容。',
  quickLinks: [
    { label: '最新快讯', href: '#updates' },
    { label: '专题合集', href: '#index' },
    { label: '焦点专题', href: '#carousel' },
    { label: '热度榜单', href: '#ranking' },
    { label: '吃瓜问答', href: '#faq' },
  ],
  copyright: '© 2026 52吃瓜网 52chigua.com 版权所有',
};